<template>
<div class="chapter">
<div class="inner_page">
<p class="h1a">Portland Food Cart Culture</p>
<p class="noindent">Portland is a food cart mecca. In a sea of multicultural flavors and quirky personalities, only the most interesting food cart concepts survive. Several Portland cart chefs who strive to serve a sustainable, local menu celebrate the bounty of food offered by the Pacific Northwest, while other chefs source worldly ingredients unique to their menus. But no matter which cart you are dining at, there’s an interesting story and unique recipe to be found in bigfoot country.</p>
<p class="indent">Among the carts sprawled throughout Stumptown, most are grouped together in pods, sharing lots with a few other carts. For example, food carts are grouped at all these various intersections and more: Southwest 3<sup>rd</sup> and Ash, the Alder Pod, Mississippi Marketplace, 5<sup>th</sup> and Stark, Cartopia, Cartlandia, 23<sup>rd</sup> and Alberta, Rose City Food Park, the Row, etc.</p>
<p class="indent">Locals rely on a handful of food cart authorities such as Brett Burmeister behind Food Carts Portland; Steven Shomler, author of <i>Portland Food Cart Stories</i> and founder of Portland Food Cart Adventures; Scott Batchelar of Food Carts for Charity; and Aaron Wakamatsu of Aaron’s Food Adventures.</p>
<p class="indent">In addition to an abundance of food options, Portland is known for its beautiful landscape. From roses to waterfalls, hikes at the Gorge to fishing or surfing at the coast, this food cart hub lends itself to several outdoor outlets worth exploring.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// portland.vue?28571e81